import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useState } from "react";
import { MuiBox, MuiButtonSecondary, MuiModal } from "..";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { getSafeImageUrl } from "../../helpers/utils";
import { useSiteCore } from "../../hooks/useSiteCore";
import { CardForExternalLinkWrapper } from "./CardForExternalLink.style";

interface CardForExternalLinkProps {
  reportUrl: string;
  reportName: string;
  reportImageUrl: string;
  reportImageAltText?: string;
  popupModalText?: string;
  primaryBtnText?: string;
  secondaryBtnText?: string;
}

export const CardForExternalLink: React.FC<CardForExternalLinkProps> = ({
  reportUrl,
  reportName,
  reportImageUrl,
  reportImageAltText,
  popupModalText,
  primaryBtnText,
  secondaryBtnText,
}) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const { commonLabels } = useSiteCore();

  return (
    <CardForExternalLinkWrapper>
      <MuiButtonSecondary
        id={COMPONENT_IDS.COMMON_HEADER_ACTION_BUTTON}
        className="button-with-external-link"
        onClick={() => setShowPopup(true)}
      >
        <MuiBox className="left-content">
          <MuiBox className="icon-wrapper">
            <img
              src={getSafeImageUrl(reportImageUrl)}
              className="icon"
              alt={reportImageAltText}
            />
          </MuiBox>
          <MuiBox className="report-name">{reportName}</MuiBox>
        </MuiBox>

        <OpenInNewIcon
          data-testid={COMPONENT_IDS.COMMON_ACCORDION_ADD_ICON}
          color="primary"
          className="open-in-new-tab-icon"
        />
      </MuiButtonSecondary>

      {showPopup && (
        <MuiModal
          open={showPopup}
          onClose={() => setShowPopup(false)}
          title={commonLabels.information}
          primaryButtonTitle={primaryBtnText}
          secondaryButtonTitle={secondaryBtnText || commonLabels.cancel}
          onPrimaryButtonClick={() => {
            setShowPopup(false);
            window.open(reportUrl, "_blank");
          }}
          onSecondaryButtonClick={() => setShowPopup(false)}
        >
          <>{popupModalText}</>
        </MuiModal>
      )}
    </CardForExternalLinkWrapper>
  );
};
